// Application routes
const ROUTES = {
    // Public routes
    PUBLIC: {
      HOME: '/',
      LOGIN: '/login',
      REGISTER: '/register',
      FORGOT_PASSWORD: '/forgot-password',
      RESET_PASSWORD: '/reset-password',
    },
    
    // Protected routes
    PROTECTED: {
      DASHBOARD: '/dashboard',
      BUDGETS: '/budgets',
      BUDGET_DETAIL: (id = ':id') => `/api/budgets/${id}`,
      TRANSACTIONS: '/transactions',
      PROFILE: '/profile',
      SETTINGS: '/settings',
    },
    
    // Admin routes (if applicable)
    ADMIN: {
      DASHBOARD: '/admin',
      USERS: '/admin/users',
    },
  };
  
  export default ROUTES;